


















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component<Modal>({})
export default class Modal extends Vue {}
